import { noddiColors, NoddiIcon } from 'noddi-ui-common';
import { WheelSetStatus, WheelSetStatusType } from './types';

export { getOverallWheelSetStatus, treadDepthWheelSetStatus } from './wheelSetStatus';

export const wheelSetStatusToTranslation = (
  wheelSetStatus: WheelSetStatusType,
  translations: {
    missingMeasurements: string;
    inAGoodCondition: string;
    soonWornOut: string;
    wornOut: string;
  }
) => {
  switch (wheelSetStatus) {
    case WheelSetStatus.MissingMeasurements:
      return translations.missingMeasurements;
    case WheelSetStatus.Satisfactory:
      return translations.inAGoodCondition;
    case WheelSetStatus.SoonWornOut:
      return translations.soonWornOut;
    case WheelSetStatus.WornOut:
      return translations.wornOut;
  }
};

export const resolveWheelSetStatusLogo = (status: WheelSetStatusType) => {
  switch (status) {
    case WheelSetStatus.Satisfactory:
      return <NoddiIcon name='Check' size='medium' color={noddiColors.success} />;
    case WheelSetStatus.SoonWornOut:
      return <NoddiIcon name='TriangleAlert' color={noddiColors.warning} size='medium' />;
    case WheelSetStatus.WornOut:
      return <NoddiIcon name='X' color={noddiColors.danger} size='medium' />;
    case WheelSetStatus.MissingMeasurements:
      return null;
    default:
      return <NoddiIcon name='X' color={noddiColors.danger} size='medium' />;
  }
};
